<template>
  <div>
    <section class="p-5 text-center block w-full text-lg animate-pulse bg-slate-100 rounded-lg" v-if="!fetchdata">{{  localize.qm_loading[lang] }}</section>
    <section v-if="fetchdata"
             class="grid gap-3 lg:gap-8 grid-cols-1 lg:grid-cols-2"
    >
      <figure :class="bg_otd"
              class="text-white text-center rounded-md py-4 shadow-lg"
      >
        <span class="text-[5.5rem]"
              v-text="otd"
        ></span> %
        <figcaption class="qm-item">{{ localize.qm_label_otd[lang] }}</figcaption>
      </figure>
      <figure :class="bg_qi"
              class="text-white text-center rounded-md py-4 shadow-lg"
      >
        <span class="text-[5.5rem]"
              v-text="qi"
        ></span>
        <figcaption class="qm-item">{{ localize.qm_label_qi[lang] }}</figcaption>
      </figure>
    </section>

    <section v-if="fetchdata"
             class="grid gap-3 lg:gap-8 grid-cols-1 lg:grid-cols-3 mt-3 lg:mt-10"
    >
      <figure :class="bg_qup"
              class="text-white text-center rounded-md py-4 shadow-lg"
      >
        <span class="text-[4rem]"
              v-text="qup"
        ></span>%
        <figcaption class="qm-item">{{ localize.qm_label_paper_waste[lang] }} <br><span class="text-sm">(kg/1.000EUR {{ localize.qm_label_umsatz[lang] }})</span></figcaption>
      </figure>
      <figure :class="bg_quv"
              class="text-white text-center rounded-md py-4 shadow-lg"
      >
        <span class="text-[4rem]"
              v-text="quv"
        ></span>%
        <figcaption class="qm-item">{{ localize.qm_label_packaging_waste[lang] }} <br><span class="text-sm">(kg/1.000EUR {{ localize.qm_label_umsatz[lang] }})</span></figcaption>
      </figure>
      <figure :class="bg_que"
              class="text-white text-center rounded-md py-4 shadow-lg"
      >
        <span class="text-[4rem]"
              v-text="que"
        ></span>%
        <figcaption class="qm-item">{{ localize.qm_label_energie_consumption[lang] }} <br><span class="text-sm">(kWh/1.000EUR {{ localize.qm_label_umsatz[lang] }}</span>)</figcaption>
      </figure>

    </section>

  </div>

</template>
<script setup>
import {onMounted, ref} from "vue";
import localize from "../lang/localize.json"

const props = defineProps({
  lang: {
    type: String,
    default: 'de'
  }
})

const fetchdata = ref({})

onMounted(async () => {
  fetchdata.value = await fetch("https://portal.thermo-control.com/API/api_sendQMData.php?api_key=KAyAcRJZUacAYGRCeCfZXRAAAIQgAAEIACBxAggThJDyY0gAAEIQAACEIAABCAAgXoIIE7q");
  let data = await fetchdata.value.json();

  if (data.resp === 200) {
    // counterCS: 100
    otd.value = data.counterOTD;
    qi.value = data.counterQI;
    qup.value = data.counterUmP;
    quv.value = data.counterUmV;
    que.value = data.counterUmE;
    bg_otd.value = getOTDbgcolor(data.counterOTD)
    bg_qi.value = data.counterQI > 0 ? 'bg-red-500' : 'bg-green-500'
    bg_qup.value = data.counterUmP >= 0 ? 'bg-red-500' : 'bg-green-500'
    bg_quv.value = data.counterUmV >= 0 ? 'bg-red-500' : 'bg-green-500'
    bg_que.value = data.counterUmE >= 0 ? 'bg-red-500' : 'bg-green-500'
  } else {
    otd.value = 33;
    qi.value = 33;
    qup.value = 33;
    quv.value = 33;
    que.value = -5;
  }

})

const otd = ref(95)
const qi = ref(0)
const qup = ref(-5)
const quv = ref(-5)
const que = ref(-5)

const bg_otd = ref('bg-slate-100')
const bg_qi = ref('bg-slate-100')
const bg_qup = ref('bg-slate-100')
const bg_quv = ref('bg-slate-100')
const bg_que = ref('bg-slate-100')

function getOTDbgcolor(value) {
  if (value < 75) {
    return 'bg-red-500'
  }
  if (value < 90 && value >= 75) {
    return 'bg-yellow-500'
  }
  if (value < 100 && value >= 90) {
    return 'bg-green-500'
  }
  return 'bg-slate-100'
}


</script>